import { configureTranslationWarnings } from './configureTranslationWarnings';

configureTranslationWarnings();

export * from '@creditinfo-ui/messages';
